{% block ecocode_trustpilot_first_run_wizard_finish %}
    <div class="ecocode-trustpilot-first-run-wizard-finish">

        <span class="ecocode-trustpilot-first-run-wizard-finish__bubble">
            <sw-icon class="ecocode-trustpilot-first-run-wizard-finish__icon"
                     name="checkmark"
                     size="42px"
                     small>
            </sw-icon>
        </span>
        <h3 class="headline-success">{{ $tc('sw-first-run-wizard.finish.headlineAllDone') }}</h3>
        <p>
            {{ $tc('ecocode-trustpilot.finish.modalBody') }}
        </p>
    </div>
{% endblock %}
